import dayjs from "dayjs";
import { Button } from "../../Atoms/Button";
import { InputDate } from "../../Atoms/Inputs/InputDate";
import { Pagination } from "../../Atoms/Pagination";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { LayoutTemplate } from "../../Templates/LayoutTemplate";
import * as S from "./styles";
import { useReports } from "./useReports";
import { v4 } from "uuid";
import { ISelectOptions } from "../../../types/inputs";
import { formatISOToDateBR } from "../../../utils/dateTransform";

export const Reports = () => {
  const {
    filterOpen,
    setFilterOpen,
    isMobile,
    navigate,
    filter,
    pagination,
    updateFilter,
    setNumberPage,
    denuncias,
    TipoAssedioOptions,
    handleClearFilter,
    handleFillter,
  } = useReports();

  return (
    <LayoutTemplate>
      <S.Container>
        <h1>Denúncias de Abuso</h1>

        <S.WrapperFilter>
          <Button
            data-variant-outline
            type="button"
            onClick={() => setFilterOpen((prev) => !prev)}
          >
            <img alt="filter" src="/assets/svgs/icon-filter-dark.svg" /> Filtrar
          </Button>

          {filterOpen && (
            <S.ReportFilter onSubmit={handleFillter}>
              <div>
                <InputDate
                  label="Data Inicial"
                  showIcon
                  placeholderText="__/__/__"
                  selected={
                    filter?.dataInicial
                      ? dayjs(filter.dataInicial).toDate()
                      : null
                  }
                  onChange={(e) =>
                    updateFilter({
                      dataInicial: dayjs(e).format("YYYY-MM-DD"),
                    })
                  }
                />
              </div>

              <div>
                <InputDate
                  label="Data Final"
                  showIcon
                  placeholderText="__/__/__"
                  selected={
                    filter?.dataFinal ? dayjs(filter.dataFinal).toDate() : null
                  }
                  onChange={(e) =>
                    updateFilter({
                      dataFinal: dayjs(e).format("YYYY-MM-DD"),
                    })
                  }
                />
              </div>

              <div>
                <SimpleSelect
                  label="Tipo de Assédio"
                  options={TipoAssedioOptions}
                  value={
                    TipoAssedioOptions.find(
                      (t) => t.value === filter.tipoAssedio
                    ) || null
                  }
                  onChange={(e: ISelectOptions) => {
                    updateFilter({ tipoAssedio: e?.value });
                  }}
                />
              </div>

              <div>
                <Button
                  data-variant-filter
                  type="button"
                  onClick={handleClearFilter}
                >
                  Limpar tudo
                </Button>
                <Button>Buscar</Button>
              </div>
            </S.ReportFilter>
          )}
        </S.WrapperFilter>

        <S.WrapperGridItems>
          {denuncias?.length > 0 &&
            denuncias.map((d) => (
              <S.GridItem key={d.uuid}>
                <S.GridItemContent>
                  <p>
                    Data:{" "}
                    <span>{formatISOToDateBR(d?.createdAt)}</span>
                  </p>
                  <p>
                    Nome Acusado: <span>{d?.nomeAcusado}</span>
                  </p>
                  <p>
                    Cargo: <span>{d?.cargoAcusado}</span>
                  </p>
                  <p>
                    Tipo de ássedio: <span>{d?.tipoAssedio}</span>
                  </p>
                </S.GridItemContent>
                <div>
                  <img
                    onClick={() => navigate(`/denuncias/${d?.uuid}`)}
                    src="/assets/svgs/eye.svg"
                    alt="icon olho"
                  />
                </div>
              </S.GridItem>
            ))}
        </S.WrapperGridItems>

        <S.WrapperPagination>
          <Pagination
            maxPageNumbersDisplayed={isMobile ? 3 : 10}
            key={`${v4()} - ${pagination}`}
            totalPage={pagination.totalPage}
            totalRegister={pagination.totalPage}
            actualPage={pagination.actualPage}
            setNumberPage={setNumberPage}
          />
        </S.WrapperPagination>

        <S.ToBack type="button" onClick={() => navigate(-1)}>
          Voltar
        </S.ToBack>
      </S.Container>
    </LayoutTemplate>
  );
};
